import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

function OwnerDetailsPreview(props){
    const [registration, setRegistration] = useState(props.registration);
    const [ownerDetails, setOwnerDetails] = useState(props.ownerDetails);
    const [dropdowns, setDropdowns] = useState(props.dropdowns);

    useEffect(() => {
        setRegistration(props.registration);
        setOwnerDetails(props.ownerDetails);
        setDropdowns(props.dropdowns);
    },[]);

    const formatDropdown = (cell, field) => {
        if(field == 'regions'){
            let reg = (dropdowns[field] !== undefined) ? dropdowns[field].filter(rg => rg.code == cell) : [];
            return (reg[0]!==undefined) ? reg[0].name : cell;
        }else if(field == 'districts'){
            let dist = (dropdowns[field] !== undefined) ? dropdowns[field].filter(dt => dt.id == cell) : [];
            return (dist[0]!==undefined) ? dist[0].name : cell;
        }else{
            let drop = (dropdowns[field] !== undefined) ? dropdowns[field].filter(dd => dd.ivalue == cell) : [];
            return (drop[0] !== undefined) ? drop[0].iname : cell;
        }
    }

    return(
        <div className="row preview">
            <div className="col-12">
            <br /><hr /><h5>Owner <span>Details</span><button className="btn text-primary" onClick={() => props.editForm(4)}><FontAwesomeIcon icon={faEdit} size="sm" /></button></h5>
            </div>
            <div className="col-xs-12 col-md-6">
                <ul>
                    <li>First Name:<span>{ownerDetails.firstname} </span></li>
                    <li>Last Name:<span>{ownerDetails.lastname} </span></li>
                    <li>Other Names:<span>{ownerDetails.othernames} </span></li>
                    <li>Residential Address:<span>{ownerDetails.address_res} </span></li>
                    <li>GPS Address:<span>{ownerDetails.gps} </span></li>
                    <li>Postal Address:<span>{ownerDetails.address_postal} </span></li>
                    <li>Nearest Landmark:<span>{ownerDetails.landmark} </span></li>   
                    {/* <li>Marital Status:<span>{formatDropdown(ownerDetails.age_bracket,'age_bracket')} </span></li> */}
                    <li>Date of Birth:<span>{moment(ownerDetails.birth_date).format('DD MMM, YYYY')} </span></li>
                </ul>
            </div>
            <div className="col-xs-12 col-md-6">
                <ul>
                    <li>Personal Phone 1:<span>{ownerDetails.mobile} </span></li>
                    <li>Personal Phone 2:<span>{ownerDetails.phone} </span></li>
                    <li>Region:<span>{formatDropdown(ownerDetails.region,'regions')} </span></li>
                    <li>District:<span>{formatDropdown(ownerDetails.district,'districts')} </span></li>
                    <li>Town:<span>{ownerDetails.town} </span></li>
                    <li>ID Type:<span>{formatDropdown(ownerDetails.idtype,'idtype')} </span></li>
                    <li>ID Number:<span>{ownerDetails.idno} </span></li>
                    <li>Gender:<span>{formatDropdown(ownerDetails.gender,'gender')} </span></li>
                    <li>Do You Have Any Disability:<span>{ownerDetails.disability == 0 ? 'No' : 'Yes'} </span></li>
                    <li>Female-Majority Owned Business?<span>{ownerDetails.female_dominated == 1 ? 'Yes' : 'No'} </span></li>
                </ul>
            </div>
            
            <div className="col-xs-12 col-md-6">
                <ul>
                    <li>Is the person completing this form same as the business owner?<span>{ownerDetails.isapplicant_owner == 0 ? 'No' : 'Yes'} </span></li>
                    {ownerDetails.isapplicant_owner == 0 && <>
                    <li>Full Name:<span>{ownerDetails.rep_name} </span></li>
                    <li>Title :<span>{ownerDetails.rep_title} </span></li>
                    <li>Phone Number:<span>{ownerDetails.rep_phone} </span></li>
                    <li>Email Address:<span>{ownerDetails.rep_email} </span></li>
                    <li>Residential Address:<span>{ownerDetails.rep_address_res} </span></li>
                    <li>ID Type:<span>{formatDropdown(ownerDetails.rep_idtype,'idtype')} </span></li>
                    <li>ID Number:<span>{ownerDetails.rep_idno} </span></li>
                    </>}
                </ul>
            </div>
            
        </div>
    );
}

export default OwnerDetailsPreview;